import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const Main2SectionWrap = styled.div`
  width: 100%;
  margin: 0 auto 321px auto;
  max-width: 1100px;
  text-align: center;

  > div {
    display: block;

    > h3 {
      margin-top: 155px;
      font-family: NotoSansBold, sans-serif;
      font-size: 60px;
      line-height: 87px;
    }
  }

  ${customMedia.lessThan('tablet')`
     width: 328px;
     margin: 0 auto;
     > div{
        >h3{
            font-family: NanumSquareNeoExtraBold, san-serif;
            font-size: 24px;
            line-height: 27px;
            margin: 0;
            padding: 55px 0 65px 0;
        }
     }
  `}
`
const Main2SectionContent = styled.section<{ bgSrc: string; boxShadow: string }>`
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-image: url(${(props) => props.bgSrc});
  box-shadow: 0 4px 20px 0 ${(props) => props.boxShadow};
  border-radius: 64px;
  height: 360px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 64px;
  margin-top: 180px;

  > div {
    text-align: left;

    > p {
      margin: 0;
      padding: 0 0 0 78px;
      font-size: 18px;
      line-height: 26px;
      color: ${COLOR.gray70};
      font-family: NotoSansRegular, sans-serif;
    }

    > h3 {
      padding: 136px 0 18px 78px;
      margin: 0;
      font-family: NanumSquareNeoExtraBold, sans-serif;
      font-size: 40px;
      line-height: 44px;
    }
  }

  .lottie {
    margin: -116px 0 0 0;
    display: flex;
    width: 500px;
    height: 476px;
  }

  ${customMedia.lessThan('tablet')`
    display: flex;
    height: 385px;
    flex-direction: column;
    margin: 0 0 63px 0;
    background-size: contain;
    background-position: 50% 100%;
    box-shadow: none;
    >div{
        width: 100%;
        text-align: center;
      >h3{
        padding: 0;
        font-family: NanumSquareNeoHeavy, san-serif;
        font-size: 18px;
        line-height: 20px;
        margin-bottom: 8px;
      }
      >p{
        padding: 0 16px;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .lottie{
      margin: 5px 0 0 0;
      padding: 0;  
      width: 100%;
      height: 312px;
      >svg{
           border-radius: 64px;
      }
    }
  `}
`
export { Main2SectionContent, Main2SectionWrap }
